'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.CollapsablePanel', []).directive('rmCollapsablePanel', require('./directives/CollapsablePanelDirective'));